import React from 'react';
import {UsersClientActionsLoadingDialog} from './UsersClientActionsLoadingDialog';
import {UsersClientActionsProvider} from '../context/UsersClientActionsContext';
import {UsersClientActionsCard} from './UsersClientActionsCard';

export function UsersClientActionsPage() {

  return (
    <UsersClientActionsProvider>
      <UsersClientActionsLoadingDialog />
      <UsersClientActionsCard />
    </UsersClientActionsProvider>
  );
}